import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { of, Subscription, switchMap, tap } from 'rxjs';
import { usersManageApi } from 'src/app/shared/constants/api.constants';
import { HelpersService, HttpBaseService }   from '@evento-ng/libs';
import { UserService } from '../user.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
})
export class EventsComponent implements OnInit {
  events = {
    data: Array(10),
    meta: null,
  };
  page = 1;
  subs: Subscription[] = [];
  constructor(
    private userService: UserService,
    private dataService: HttpBaseService,
    public helpers: HelpersService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subs.push(
      this.userService.selectedUser$
        .pipe(
          switchMap((user) => {
            if (user) {
              return this.dataService
                .get(`${usersManageApi}/tickets/${user.id}`, {
                  params: {
                    page: this.page,
                  },
                })
                .pipe(
                  tap((res) => {
                    this.spinner.hide();

                    this.events = res;
                  })
                );
            }
            return of({
              data: Array(10),
              meta: null,
            });
          })
        )
        .subscribe()
    );
  }

  viewEvent(eventId: string): void {
    this.router.navigate(['/dashboard/event/' + eventId + '/overview']);
  }
}
